export default __webpack_public_path__ + "static/media/tbnail-03.png";